var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { createFilterStyle } from './createStyle';
import Button from '../button/index.react';

var Filter = function Filter(_a) {
  var active = _a.active,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {} : _c,
      className = _a.className,
      children = _a.children,
      props = __rest(_a, ["active", "disabled", "onClick", "className", "children"]);

  var finalClassName = createFilterStyle({
    className: className
  });
  return React.createElement(Button, __assign({
    size: "small",
    "aria-selected": active,
    "aria-label": name,
    className: finalClassName,
    selected: active,
    disabled: disabled,
    onClick: onClick,
    theme: "secondary"
  }, props), children);
};

export default Filter;